import { brioche } from "@9amhealth/shared";
import { LinkButton } from "atom/button/LinkButton";
import { IconCheckmarkWhite } from "src/constants/icons";
import Path from "src/constants/path";
import { createAppPath } from "src/lib/createAppPath";
import { dismissBrioche } from "src/lib/dismissBrioche";
import { historyState } from "src/state/state";
import Translate from "src/ui/components/Translate/Translate";

const ABANDON_WAIT_FOR_HOME_MS = 2000;

const presentMealSavedBrioche = (navigate: (path: string) => void): void => {
  brioche.success({
    icon: <IconCheckmarkWhite />,
    content: <Translate msg="mealInsights.saved" />,
    controls: (
      <LinkButton onPress={() => navigate(createAppPath(Path.meals))}>
        <Translate msg="view" />
      </LinkButton>
    ),
    dismissFn: dismissBrioche
  });
};

export const showMealSavedToast = (navigate: (path: string) => void): void => {
  const pending: {
    subscription?: { unsubscribe: () => void };
    abandonTimeout?: ReturnType<typeof setTimeout>;
    sawSubscribeNotification: boolean;
  } = { sawSubscribeNotification: false };

  const stopWaitingForHome = () => {
    pending.subscription?.unsubscribe();
    clearTimeout(pending.abandonTimeout);
  };

  pending.subscription = historyState.subscribe({
    next: () => {
      if (!pending.sawSubscribeNotification) {
        pending.sawSubscribeNotification = true;
        return;
      }
      stopWaitingForHome();
      queueMicrotask(() => presentMealSavedBrioche(navigate));
    }
  });

  pending.abandonTimeout = setTimeout(
    stopWaitingForHome,
    ABANDON_WAIT_FOR_HOME_MS
  );
};
